
namespace Gamification.Gamification {
    export class UtentiDatiColumns {
        static columnsKey = 'Gamification.UtentiDati';
    }
}